import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-32e3ff26")

_pushScopeId("data-v-32e3ff26")
const _hoisted_1 = { class: "ui__reportResult_main" }
const _hoisted_2 = { class: "ui__reportResult_body" }
const _hoisted_3 = { class: "ui__reportResult_title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "ui__reportResult_title_left" }, "已通过检测", -1)
const _hoisted_5 = { class: "ui__reportResult_title_right" }
const _hoisted_6 = { class: "ui__reportResult_content" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "ui__reportResult_content_title" }, " 经检测此车经过268V实车检测，非重大事故车、非火烧车、非泡水车 ", -1)
const _hoisted_8 = { class: "ui__reportResult_content_img" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, "· " + _toDisplayString(_ctx.state.quality) + " " + _toDisplayString(_ctx.state.condition), 1)
      ]),
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode("div", _hoisted_8, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.photoList.slice(0,5), (item, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "ui__reportResult_content_img_item",
              key: item.photoIdStr
            }, [
              (index < 4)
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    src: item.smallPhotoUrl ? item.smallPhotoUrl : item.photoPath,
                    onClick: ($event: any) => (_ctx.goPhoto(item))
                  }, null, 8, ["src", "onClick"]))
                : _createCommentVNode("", true),
              (index === 4)
                ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                    _createVNode("img", {
                      src: item.smallPhotoUrl
                    }, null, 8, ["src"]),
                    _createVNode("div", {
                      class: "ui__reportResult_content_img_item_cover",
                      onClick: ($event: any) => (_ctx.goPhoto(item, 'total'))
                    }, [
                      _createVNode("h6", null, _toDisplayString(_ctx.state.photoLength) + "张", 1)
                    ], 8, ["onClick"])
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
})